const RETURN_STORAGE_KEY = 'paymentReturnPath';
const RETURN_TTL_MS = 60 * 60 * 1000;
const RETURN_MARKER = 'mb_app=cart/confirm';

const decodeSafe = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    console.log('error decode payment return url', error);
    return value;
  }
};

export const isPaymentReturnUrl = (
  href: string = window.location.href
): boolean =>
  href.includes(RETURN_MARKER) || decodeSafe(href).includes(RETURN_MARKER);

export const isTrustedPaymentOrigin = (origin: string): boolean => {
  if (!origin || origin === window.location.origin) {
    return true;
  }
  try {
    const { hostname } = new URL(origin);
    return (
      hostname === 'delikateska.ru' || hostname.endsWith('.delikateska.ru')
    );
  } catch (error) {
    console.log('error isTrustedPaymentOrigin', error);
    return false;
  }
};

const isSafeReturnPath = (path: unknown): path is string =>
  typeof path === 'string' &&
  path.charAt(0) === '/' &&
  path.charAt(1) !== '/' &&
  !isPaymentReturnUrl(path);

export const savePaymentReturnPath = (customPath?: string): void => {
  const path =
    customPath ||
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (!isSafeReturnPath(path)) {
    return;
  }

  try {
    localStorage.setItem(
      RETURN_STORAGE_KEY,
      JSON.stringify({ path, ts: Date.now() })
    );
  } catch (error) {
    console.log('error savePaymentReturnPath', error);
  }
};

export const clearPaymentReturnPath = (): void => {
  try {
    localStorage.removeItem(RETURN_STORAGE_KEY);
  } catch (error) {
    console.log('error clearPaymentReturnPath', error);
  }
};

export const readPaymentReturnPath = (): string | null => {
  try {
    const saved = localStorage.getItem(RETURN_STORAGE_KEY);
    if (!saved) {
      return null;
    }
    const { path, ts } = JSON.parse(saved) as { path?: string; ts?: number };
    if (!ts || Date.now() - ts > RETURN_TTL_MS || !isSafeReturnPath(path)) {
      return null;
    }
    return path;
  } catch (error) {
    console.log('error readPaymentReturnPath', error);
    return null;
  }
};
